import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "optionRoofBox"
const OptionRoofBoxIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m9.497 4h6.006c1.655 0 2.997 1.347 2.997 3v2.009c0 .548-.456.991-1.003.991h-9.994c-.554 0-1.003-.451-1.003-.991v-2.009c0-1.657 1.342-3 2.997-3zm-2.497 19c-.828 0-1.5-.671-1.5-1.5s.672-1.5 1.5-1.5 1.5.671 1.5 1.5-.672 1.5-1.5 1.5zm11 0c-.828 0-1.5-.671-1.5-1.5s.672-1.5 1.5-1.5 1.5.671 1.5 1.5-.672 1.5-1.5 1.5zm-12-5c0-1 0-5 3.5-5h6c3.5 0 3.5 4 3.5 5zm10-7h-7c-2.36 0-4.039 1.82-4.882 4.539-.118-.026-.242-.039-.368-.039-.967 0-1.75.784-1.75 1.75 0 .891.666 1.627 1.528 1.736-.018.333-.028.671-.028 1.014v4h17.972l.028-4c0-.343-.01-.681-.028-1.014.862-.109 1.528-.845 1.528-1.736 0-.966-.783-1.75-1.75-1.75-.126 0-.25.013-.368.039-.843-2.719-2.522-4.539-4.882-4.539z" />
    </svg>
  )
}
export default OptionRoofBoxIcon
